import React, { useState } from 'react';

const TYPES = [
  'Fonctionnel', 'Performance', 'Utilisabilité', 'Compatibilité',
  'Fiabilité', 'Sécurité', 'Maintenabilité', 'Portabilité', 'Sureté'
];
const LEVELS = ['Haut', 'Moyen', 'Faible'];

export default function RequirementForm({ initial, onSubmit, onCancel }) {
  const [form, setForm] = useState(initial || {
    exg_id: '', exigence: '', desc_exigence: '',
    type_exigence: 'Fonctionnel', impact: 'Moyen', probabilite: 'Moyen', position: 0,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-2 mb-2">
        <div className="col-md-2">
          <label className="form-label small" htmlFor="field-exg-id">ID Exigence</label>
          <input id="field-exg-id" className="form-control form-control-sm" value={form.exg_id}
                 onChange={(e) => setForm({ ...form, exg_id: e.target.value })} required maxLength={20} />
        </div>
        <div className="col-md-4">
          <label className="form-label small" htmlFor="field-exigence">Exigence</label>
          <input id="field-exigence" className="form-control form-control-sm" value={form.exigence}
                 onChange={(e) => setForm({ ...form, exigence: e.target.value })} required maxLength={300} />
        </div>
        <div className="col-md-2">
          <label className="form-label small" htmlFor="field-type-exigence">Type</label>
          <select id="field-type-exigence" className="form-select form-select-sm" value={form.type_exigence}
                  onChange={(e) => setForm({ ...form, type_exigence: e.target.value })}>
            {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div className="col-md-2">
          <label className="form-label small" htmlFor="field-impact">Impact</label>
          <select id="field-impact" className="form-select form-select-sm" value={form.impact}
                  onChange={(e) => setForm({ ...form, impact: e.target.value })}>
            {LEVELS.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        <div className="col-md-2">
          <label className="form-label small" htmlFor="field-probabilite">Probabilité</label>
          <select id="field-probabilite" className="form-select form-select-sm" value={form.probabilite}
                  onChange={(e) => setForm({ ...form, probabilite: e.target.value })}>
            {LEVELS.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
      </div>
      <div className="mb-2">
        <label className="form-label small" htmlFor="field-desc-exigence">Description</label>
        <textarea id="field-desc-exigence" className="form-control form-control-sm" rows="2" value={form.desc_exigence}
                  onChange={(e) => setForm({ ...form, desc_exigence: e.target.value })} />
      </div>
      <div className="d-flex gap-2">
        <button type="submit" className="btn btn-primary btn-sm">Enregistrer</button>
        {onCancel && <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>Annuler</button>}
      </div>
    </form>
  );
}
